module.exports = __webpack_public_path__ + "static/media/flash1.49a1b751.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/flash1.png
// module id = 126
// module chunks = 0